import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import PageHero from '../components/PageHero';
import useReveal from '../hooks/useReveal';
import { fagentreprisePage, disciplines, environments } from '../mock';

const Fagentreprise = () => {
  const ref = useReveal();
  const p = fagentreprisePage;
  return (
    <div ref={ref}>
      <PageHero eyebrow={p.hero.eyebrow} title={p.hero.title} image={p.hero.image} />

      {/* INTRO */}
      <section className="bg-bone">
        <div className="mx-auto max-w-[1100px] px-6 md:px-12 py-24 md:py-32 reveal">
          <p className="font-serif font-light text-2xl md:text-4xl leading-[1.4]">{p.intro}</p>
        </div>
      </section>

      {/* DISCIPLINES — alternating rows */}
      <section className="bg-paper border-y border-ink/10">
        <div className="mx-auto max-w-[1500px] px-6 md:px-12 py-16 md:py-24">
          {disciplines.map((d, idx) => (
            <div
              key={d.title}
              className={`grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center py-12 md:py-20 ${
                idx !== disciplines.length - 1 ? 'border-b border-ink/10' : ''
              }`}
            >
              <div className={`img-hover-zoom aspect-[4/3] reveal ${idx % 2 === 1 ? 'md:order-2' : ''}`}>
                <img src={d.image} alt={d.title} className="h-full w-full object-cover" />
              </div>
              <div className="reveal">
                <div className="font-serif text-clay text-xl">{d.no}</div>
                <h2 className="mt-4 font-serif font-light text-3xl md:text-5xl">{d.title}</h2>
                <p className="mt-6 max-w-md text-base font-light leading-relaxed text-stone">{d.long}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ENVIRONMENTS */}
      <section className="bg-bone">
        <div className="mx-auto max-w-[1500px] px-6 md:px-12 py-24 md:py-32">
          <div className="reveal mb-12 max-w-2xl">
            <p className="text-[11px] uppercase tracking-[0.3em] text-stone">{environments.eyebrow}</p>
            <h2 className="mt-5 font-serif font-light text-4xl md:text-5xl">{environments.title}</h2>
            <p className="mt-5 text-sm md:text-base font-light leading-relaxed text-stone">
              {environments.subtitle}
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {environments.categories.map((c) => (
              <div key={c.title} className="reveal">
                <div className="img-hover-zoom aspect-square w-full">
                  <img src={c.image} alt={c.title} className="h-full w-full object-cover" />
                </div>
                <p className="mt-4 text-[11px] uppercase tracking-[0.2em] text-stone">{c.title}</p>
              </div>
            ))}
          </div>
          <p className="reveal mt-10 text-xs font-light italic text-stone/80">{environments.note}</p>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-ink text-bone">
        <div className="mx-auto max-w-[1100px] px-6 md:px-12 py-24 md:py-32 text-center reveal">
          <h2 className="font-serif font-light text-3xl md:text-5xl leading-tight">{p.cta.title}</h2>
          <Link
            to={p.cta.path}
            className="mt-10 inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.25em] border-b border-bone/50 pb-1 hover:border-bone transition-colors"
          >
            {p.cta.label} <ArrowRight size={14} strokeWidth={1.4} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Fagentreprise;
